export default {"src":"/_next/static/media/orleans.98d21bf7.svg","height":72,"width":535};